/**
 * Catalogue SOFI — 586 tables (discovery 2026-04-05)
 * Source : docs/architecture/SOFI_STM_v1.md + SOFI_SCHEMA_ACTUAL.json
 *
 * Medallion status :
 *   'bronze' = dans stg_sofi.* (tables SOFI miroir — ADR-020)
 *   'silver' = dans ANL_DIM_* ou ANL_FACT_*
 *   'gold'   = dans ANL_METRICS_*
 *   null     = disponible, pas encore intégré
 */
export const SOFI_CATALOG = [
    {
        name: 'Projets',
        domain: 'projets',
        rows: 32240,
        cols: 63,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.Projets',
        description: 'Projets clients — entité centrale de SOFI. Clé = NoProjet (char 9).',
        keyColumns: ['NoProjet', 'Succursale', 'StatutProjet', 'DateOuverture', 'Client_Gagnant', 'ValeurProjet'],
        fkRefs: ['Succursale→Succursales.Succursale', 'Client_Gagnant→Client.NoClient'],
        notes: "CleProjet N'EXISTE PAS — utiliser NoProjet. StatutProjet (pas Statut).",
    },
    {
        name: 'Plans',
        domain: 'projets',
        rows: 29000,
        cols: 60,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.Plans',
        description: 'Plans de signalisation. Clé composite : PLAN_No_Projet + PLAN_No_Plan.',
        keyColumns: [
            'PLAN_No_Projet',
            'PLAN_No_Plan',
            'PLAN_Version_Plan',
            'PLAN_Statut',
            'PLAN_Date_Commande',
            'PLAN_Temps_Estime',
            'PLAN_Temps_Reel',
            'PLAN_Prix',
        ],
        fkRefs: ['PLAN_No_Projet→Projets.NoProjet'],
        notes: "ClePlan N'EXISTE PAS. Assignations = noms texte (pas IDs).",
    },
    {
        name: 'Estimations',
        domain: 'projets',
        rows: 59535,
        cols: 27,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.Estimations',
        description: 'Estimations par projet. Clé composite : NoProjet + NoEstimation.',
        keyColumns: ['NoProjet', 'NoEstimation', 'Valeur_Estime', 'Valeur_Estime_Coutant', 'Valeur_Facture', 'EST_Succursale'],
        fkRefs: ['NoProjet→Projets.NoProjet', 'EST_Succursale→Succursales.Succursale'],
    },
    {
        name: 'Phases',
        domain: 'projets',
        rows: 213938,
        cols: 35,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.Phases',
        description: 'Phases de projet. Clé composite : NoProjet + NoEstimation + NoPhase.',
        keyColumns: ['NoProjet', 'NoEstimation', 'NoPhase', 'Description', 'Valeur_Estime', 'Valeur_Reel'],
        fkRefs: ['NoProjet→Projets.NoProjet'],
    },
    {
        name: 'VentesPrevuesMensuel',
        domain: 'projets',
        rows: 858636,
        cols: 7,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.VentesPrevues',
        description: 'Prévisions de ventes mensuelles par projet/estimation. Annee_Fiscale disponible directement.',
        keyColumns: ['No_Projet', 'No_Estime', 'Annee_Fiscale', 'Annee', 'Mois', 'Valeur', 'VPRVM_Valeur_Signal'],
        fkRefs: ['No_Projet→Projets.NoProjet'],
        notes: 'Pas de colonne Succursale — JOIN via Projets.',
    },
    {
        name: 'StatutsProjet',
        domain: 'projets',
        rows: 16,
        cols: 7,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.StatutsProjet',
        description: 'Lookup statuts de projet.',
        keyColumns: ['Statut', 'Description', 'STP_En_Execution', 'STP_Pour_Facturation'],
        fkRefs: [],
    },
    {
        name: 'StatutsPlans',
        domain: 'projets',
        rows: 17,
        cols: 5,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.StatutsPlans',
        description: 'Lookup statuts de plan.',
        keyColumns: ['STPL_Statut', 'STPL_Description', 'STPL_Envoye', 'STPL_Inactif'],
        fkRefs: [],
    },
    {
        name: 'TypeConception',
        domain: 'projets',
        rows: 12,
        cols: 3,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.TypeConception',
        description: 'Types de conception plan. Clé : TCP_ID_Type_Conception.',
        keyColumns: ['TCP_ID_Type_Conception', 'TCP_Description', 'TCP_Inactif'],
        fkRefs: [],
    },
    {
        name: 'RaisonRevisionParPlan',
        domain: 'projets',
        rows: 1736,
        cols: 5,
        medallion: null,
        description: 'Raisons de révision associées aux plans.',
        keyColumns: ['No_Projet', 'NoPlan', 'Version_Plan', 'ID_Raison_Revision_Plan'],
        fkRefs: ['No_Projet→Projets.NoProjet'],
    },
    {
        name: 'InclusExclusProjet',
        domain: 'projets',
        rows: 1106744,
        cols: 10,
        medallion: null,
        description: 'Inclus/Exclus par projet — très volumineuse.',
        keyColumns: ['NoProjet', 'No_Estime', 'No_Phase', 'Description', 'Inclus', 'Quantite'],
        fkRefs: ['NoProjet→Projets.NoProjet'],
    },
    {
        name: 'FactureSignalEntete',
        domain: 'facturation',
        rows: 17948,
        cols: 44,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.FactureSignal',
        description: 'Facturation signalisation — principale source revenus GS.',
        keyColumns: ['Succursale', 'Client', 'NoProjet', 'Date_Facture', 'Montant_Total', 'Statut'],
        fkRefs: ['Succursale→Succursales.Succursale', 'Client→Client.NoClient', 'NoProjet→Projets.NoProjet'],
    },
    {
        name: 'FactureEntete',
        domain: 'facturation',
        rows: 7569,
        cols: 23,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.FactureEntete',
        description: 'Facturation projets généraux.',
        keyColumns: ['No_Projet', 'Date_Facture', 'No_Facture_Interne', 'Succursale', 'FACE_Valeur_Facture_Total', 'FACE_Statut'],
        fkRefs: ['No_Projet→Projets.NoProjet', 'Succursale→Succursales.Succursale'],
    },
    {
        name: 'BordereauDetail',
        domain: 'facturation',
        rows: 228196,
        cols: 31,
        medallion: null,
        description: "Lignes de bordereau — détail main d'œuvre et véhicules facturés.",
        keyColumns: ['NoBordereau', 'Succursale', 'NoProjet', 'TypeEmploi', 'TypeVehicule', 'NbHeures', 'Montant'],
        fkRefs: ['Succursale→Succursales.Succursale', 'NoProjet→Projets.NoProjet'],
    },
    {
        name: 'BordereauPériode',
        domain: 'facturation',
        rows: 150763,
        cols: 18,
        medallion: null,
        description: 'Bordereaux par période de facturation.',
        keyColumns: ['NoBordereau', 'NoPeriode', 'Succursale', 'NoProjet', 'DateDebut', 'DateFin', 'Montant_Total'],
        fkRefs: ['Succursale→Succursales.Succursale', 'NoProjet→Projets.NoProjet'],
    },
    {
        name: 'LogPaiementFacture',
        domain: 'facturation',
        rows: 171083,
        cols: 6,
        medallion: null,
        description: 'Journal des paiements de factures.',
        keyColumns: ['NoFacture', 'DatePaiement', 'Montant', 'ModePaiement'],
        fkRefs: [],
    },
    {
        name: 'Vehicule',
        domain: 'flotte',
        rows: 1312,
        cols: 51,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.Vehicule',
        description: 'Inventaire flotte GS. VIN = colonne No_Serie.',
        keyColumns: ['NoVehicule', 'Succursale', 'Type_de_Vehicule', 'Plaque', 'No_Serie', 'Annee', 'Statut', 'Cout_Achat', 'VEH_Dernier_Odometre'],
        fkRefs: ['Succursale→Succursales.Succursale', 'Type_de_Vehicule→TypeVehicule.TypeVehicule'],
        notes: 'No_Serie = VIN. VEH_Dernier_Odometre = odomètre le plus récent (utile TCO).',
    },
    {
        name: 'TypeVehicule',
        domain: 'flotte',
        rows: 68,
        cols: 18,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.TypeVehicule',
        description: 'Types de véhicule avec taux horaires.',
        keyColumns: ['TypeVehicule', 'Description', 'Taux_Horaire_Coutant', 'Taux_Horaire_Vendant', 'Inactif'],
        fkRefs: [],
    },
    {
        name: 'MarquesVehicule',
        domain: 'flotte',
        rows: 60,
        cols: 2,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.MarquesVehicule',
        description: 'Lookup marques de véhicule.',
        keyColumns: ['ID_Marque', 'Description'],
        fkRefs: [],
    },
    {
        name: 'ModeleVehicule',
        domain: 'flotte',
        rows: 127,
        cols: 2,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.ModeleVehicule',
        description: 'Lookup modèles de véhicule.',
        keyColumns: ['ID_Modele', 'Description'],
        fkRefs: [],
    },
    {
        name: 'StatutVehicule',
        domain: 'flotte',
        rows: 25,
        cols: 4,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.StatutVehicule',
        description: 'Statuts de véhicule (SAAQ + opération).',
        keyColumns: ['NoStatutVehicule', 'Description', 'Type_Statut', 'Disponible'],
        fkRefs: [],
    },
    {
        name: 'BonMecaniqueEntete',
        domain: 'flotte',
        rows: 15080,
        cols: 29,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.BonMecanique',
        description: 'Bons de réparation mécanique interne GS.',
        keyColumns: ['BONM_ID_Bon', 'BONM_ID_Vehicule', 'BONM_Succursale', 'BONM_Statut', 'BONM_Date_Reelle', 'BONM_Montant_Main_Oeuvre', 'BONM_Montant_Pieces'],
        fkRefs: ['BONM_ID_Vehicule→Vehicule.NoVehicule', 'BONM_Succursale→Succursales.Succursale'],
    },
    {
        name: 'BonMecaniqueTypeRep',
        domain: 'flotte',
        rows: 19575,
        cols: 9,
        medallion: null,
        description: 'Types de réparation par bon méca.',
        keyColumns: ['BONMR_ID_Bon', 'BONMR_Type_Reparation', 'BNMR_Fait'],
        fkRefs: ['BONMR_ID_Bon→BonMecaniqueEntete.BONM_ID_Bon'],
    },
    {
        name: 'TypeReparationRDS',
        domain: 'flotte',
        rows: 180,
        cols: 3,
        medallion: null,
        description: 'Lookup types de réparation.',
        keyColumns: ['TREP_ID_Type_Reparation', 'TREP_Description', 'TREP_Inactif'],
        fkRefs: [],
    },
    {
        name: 'LogImprRDS',
        domain: 'flotte',
        rows: 154094,
        cols: 22,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.LogImprRDS',
        description: 'Rondes de sécurité véhicules (RDS). LOGIR_Succursle a une typo dans SOFI.',
        keyColumns: ['LOGIR_Log_ID', 'LOGIR_Succursle', 'LOGIR_NoVehicule', 'LOGIR_Date_Impression', 'LOGIR_Non_Conforme', 'LOGIR_Odometre'],
        fkRefs: ['LOGIR_NoVehicule→Vehicule.NoVehicule'],
        notes: 'TYPO SOFI : LOGIR_Succursle (pas Succursale). LOGIR_Odometre disponible.',
    },
    {
        name: 'LogChgStatutRDS',
        domain: 'flotte',
        rows: 371909,
        cols: 9,
        medallion: null,
        description: 'Historique changements de statut RDS.',
        keyColumns: ['LOGRDS_No_RDS', 'LOGRDS_Code_Vehicule', 'LOGRDS_Statut_Precedent', 'LOGRDS_Statut_Nouveau'],
        fkRefs: ['LOGRDS_Code_Vehicule→Vehicule.NoVehicule'],
        notes: 'LOGRDS_Statut_Precedent et Nouveau sont float (pas string).',
    },
    {
        name: 'Usagers',
        domain: 'rh',
        rows: 299,
        cols: 35,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.Usagers',
        description: 'Employés GS. ID_Usager = code texte char(30) (ex: "DCOLLIN").',
        keyColumns: ['ID_Usager', 'Succursale', 'Statut', 'Nom_de_Famille', 'Prenom', 'Nom_complet', 'Courriel', 'No_Employe'],
        fkRefs: ['Succursale→Succursales.Succursale'],
        notes: "Statut A=Actif (pas de colonne Inactif). IDTypeEmploi N'EXISTE PAS dans Usagers.",
    },
    {
        name: 'TypesEmploi',
        domain: 'rh',
        rows: 76,
        cols: 22,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.TypesEmploi',
        description: "Types d'emploi avec taux horaires.",
        keyColumns: ['IDTypeEmploi', 'Categorie', 'Description', 'Taux_Horaire_Coutant', 'Taux_Horaire_Vendant'],
        fkRefs: [],
        notes: 'IDTypeEmploi = char(10) — pas decimal. DISTINCT requis (doublons possibles).',
    },
    {
        name: 'PunchParJour',
        domain: 'rh',
        rows: 849702,
        cols: 17,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.PunchParJour',
        description: "Heures terrain consolidées par jour — base du TCO main d'œuvre.",
        keyColumns: ['NoProjet', 'IDEmploye', 'Date', 'Succursale', 'TypeEmploi', 'NbHeures', 'Valeur_Coutant'],
        fkRefs: ['NoProjet→Projets.NoProjet', 'Succursale→Succursales.Succursale'],
    },
    {
        name: 'OperationsPhase',
        domain: 'operations',
        rows: 910589,
        cols: 113,
        medallion: null,
        description: 'Opérations détaillées par phase — très volumineuse, 113 colonnes.',
        keyColumns: ['NoProjet', 'NoEstimation', 'NoPhase', 'Intervention_ou_Tache', 'DateDebut', 'DateFin'],
        fkRefs: ['NoProjet→Projets.NoProjet'],
    },
    {
        name: 'TypeEmpInterventionPhase',
        domain: 'operations',
        rows: 1234278,
        cols: 31,
        medallion: null,
        description: "Heures main d'œuvre par intervention/phase — table la plus volumineuse.",
        keyColumns: ['NoProjet', 'NoPhase', 'IDEmployeIntervention', 'Duree_Prevue', 'Duree_Reelle', 'Valeur_Prevue', 'Valeur_Reel'],
        fkRefs: ['NoProjet→Projets.NoProjet'],
    },
    {
        name: 'ARC_BonLocationEmploye',
        domain: 'operations',
        rows: 868859,
        cols: 48,
        medallion: null,
        description: 'Archive bons de location employés — données historiques terrain.',
        keyColumns: ['NoProjet', 'NoVehicule', 'IDEmploye', 'DateDebut', 'DateFin', 'NbHeures', 'Montant'],
        fkRefs: ['NoProjet→Projets.NoProjet', 'NoVehicule→Vehicule.NoVehicule'],
    },
    {
        name: 'Succursales',
        domain: 'config',
        rows: 19,
        cols: 42,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.Succursales',
        description: 'Table maître des 19 succursales GS.',
        keyColumns: ['Succursale', 'Nom', 'Nom_Affichage', 'NomVille', 'NomProvince', 'EMail'],
        fkRefs: [],
        notes: 'EMail (nullable). Pas de colonne Courriel ni Inactif.',
    },
    {
        name: 'Client',
        domain: 'clients',
        rows: 5758,
        cols: 33,
        medallion: 'bronze',
        stagingTable: 'stg_sofi.Client',
        description: 'Clients GS.',
        keyColumns: ['NoClient', 'NomClient', 'CLT_Type_Client', 'Statut'],
        fkRefs: [],
        notes: 'CLT_Type_Client (pas TypeClient). Statut (pas Inactif).',
    },
];
export function searchCatalog(query) {
    const q = query.toLowerCase().trim();
    if (!q)
        return SOFI_CATALOG;
    return SOFI_CATALOG.filter((t) => t.name.toLowerCase().includes(q) ||
        t.description.toLowerCase().includes(q) ||
        t.keyColumns.some((c) => c.toLowerCase().includes(q)) ||
        t.domain.includes(q));
}
export function getCatalogByDomain(domain) {
    return SOFI_CATALOG.filter((t) => t.domain === domain);
}
export function getCatalogByLayer(layer) {
    return SOFI_CATALOG.filter((t) => t.medallion === layer);
}
//# sourceMappingURL=sofiCatalog.js.map